window.sq = window.sq || {};
window.sq.config = window.sq.config || {};

//for fetching the price according to the shopify locale

window.sq.fetchPrice = function (item, isDropdown = false) {
  var selector;
  fetch(location.origin + `/products/${item.handle.toLowerCase()}.json`)
    .then((data) => data.json())
    .then((obj) => {
      if (isDropdown) {
        selector = document.querySelectorAll(
          `.sq-dropdown-body [product-handle="${item.handle}"]`
        );
      } else {
        selector = document.querySelectorAll(
          `[product-handle="${item.handle}"]`
        );
      }

      const productId = obj.product.variants[0].id;
      const variantsCount = obj.product.variants.length; // Get the number of variants

      if (obj.product.variants[0].price) {
        selector.forEach((e) => {
          if (variantsCount > 1) {
            // Show price * 2 only if there is more than one variant
            e.querySelector(`.price-item.price-item--regular`).innerHTML =
              Shopify.currency.active + " " + obj.product.variants[0].price * 2;
          } else {
            // Otherwise, show the regular price
            e.querySelector(`.price-item.price-item--regular`).innerHTML =
              Shopify.currency.active + " " + obj.product.variants[0].price;
          }
        });
      }

      if (obj.product.variants[0].compare_at_price) {
        selector.forEach((e) => {
          if (variantsCount > 1) {
            // Show compare_at_price * 2 only if there is more than one variant
            e.querySelector(`.price-item.price-item--regular`).innerHTML =
              Shopify.currency.active + " " + obj.product.variants[0].compare_at_price * 2;
          } else {
            // Otherwise, show the regular compare_at_price
            e.querySelector(`.price-item.price-item--regular`).innerHTML =
              Shopify.currency.active + " " + obj.product.variants[0].compare_at_price;
          }
        });
      }
    });
  return true;
};

// window.sq.fetchPrice = function (item, isDropdown = false) {
//   var selector;
//   fetch(location.origin + `/products/${item.handle.toLowerCase()}.json`)
//     .then((data) => data.json())
//     .then((obj) => {
//       if (isDropdown) {
//         selector = document.querySelectorAll(
//           `.sq-dropdown-body [product-handle="${item.handle}"]`
//         );
//       } else {
//         selector = document.querySelectorAll(
//           `[product-handle="${item.handle}"]`
//         );
//       }
      
//       // Check if the product ID is 48938367549768
//       const productId = obj.product.variants[0].id;
//       if (obj.product.variants[0].price) {
//         selector.forEach((e) => {
//           if (productId === 48938367549768) {
//             // Do not multiply by 2 for this specific product ID
//             e.querySelector(`.price-item.price-item--regular`).innerHTML =
//               Shopify.currency.active + " " + obj.product.variants[0].price;
//           } else {
//             // Multiply by 2 for all other products
//             e.querySelector(`.price-item.price-item--regular`).innerHTML =
//               Shopify.currency.active + " " + obj.product.variants[0].price * 2;
//           }
//         });
//       }
      
//       if (obj.product.variants[0].compare_at_price) {
//         selector.forEach((e) => {
//           if (productId === 48938367549768) {
//             // Do not multiply compare_at_price by 2 for this specific product ID
//             e.querySelector(`.price-item.price-item--regular`).innerHTML =
//               Shopify.currency.active + " " + obj.product.variants[0].compare_at_price;
//           } else {
//             // Multiply by 2 for all other products
//             e.querySelector(`.price-item.price-item--regular`).innerHTML =
//               Shopify.currency.active + " " + obj.product.variants[0].compare_at_price * 2;
//           }
//         });
//       }
//     });
//   return true;
// };


//for hiding the text from particular collections

// function searchpage() {
//   setTimeout(() => {
//     const url = window.location.href;
//     if (
//       url.includes("collections/limited-edition") ||
//       url.includes("collections/limited-edition-cashmere-blend") ||
//       url.includes("en/collections/limited-edition") ||
//       url.includes("en/collections/limited-edition-cashmere-blend")
//     ) {
//       const elements = document.querySelectorAll(
//         ".sq-customss-tex, .sq-customss-texs, a.sq-customss-tex, a.sq-customss-texs"
//       );
//       elements.forEach((element) => {
//         element.style.display = "none";
//       });
//     }
//   }, 800);
// }

// update 13/2 open comment of this block code
function collectiontext() {
  setTimeout(() => {
    const url = window.location.href;
    if (
      url.includes("collections/limited-edition") ||
      url.includes("collections/limited-edition-cashmere-blend") ||
      url.includes("en/collections/limited-edition") ||
      url.includes("en/collections/limited-edition-cashmere-blend")
    ) {
      const elements = document.querySelectorAll(
        "a.sq-limited-text"
      );
      elements.forEach((element) => {
        element.style.display = "block";
      });
    }
  }, 1000);
}

//for toggling the mobile filter
function toggleFilter() {
  let x = document.querySelector(".sq-filters1");
  const overlay = document.querySelector("sq-overlay");
  x.classList.toggle("opening");
  overlay.style.display = "block";
}
function toggleClass() {
  let y = document.querySelector(".sq-filters1");
  y.classList.remove("opening");
}
function removeClass() {
  const filterOpened = document.querySelector(".sq-filters1.opening");
  let z = document.querySelector(".sq-overlay");
  filterOpened.classList.remove("opening");
}

//for url in home page and search page
function getUrlParameter(paramName) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}
window.sq._getEachVariants = (item, store, optionKey) => {
  if (!item || !store || !optionKey) {
    ////console.error("Invalid arguments passed to _getEachVariants");
    return [];
  }
  const selectedLabel = getUrlParameter(optionKey);
  // Decode the URL-encoded string for comparison if it exists
  let decodedSelectedLabel = selectedLabel
    ? decodeURIComponent(selectedLabel).replace(/\+/g, " ").trim()
    : null;
  const filter = store.filters?.find((f) => f.stFieldName === optionKey);
  if (!filter) {
    ////console.error("Filter not found for optionKey:", optionKey);
    return [];
  }
  // Flag to track if any option has been selected
  let isAnyOptionSelected = false;
  const variants = filter.items
    .map((x, index) => {
      let isSelected;
      if (decodedSelectedLabel) {
        isSelected = x.displayLabel === decodedSelectedLabel;
        if (isSelected) isAnyOptionSelected = true;
      } else {
        // Default to the first item if no URL parameter is found
        isSelected = index === 0;
      }
      // Find the variant in item.variants where option1 matches the displayLabel
      const variant = item.variants.find(
        (v) =>
          v.option1.toLowerCase() === x.displayLabel.toLowerCase() &&
          v.inventory_quantity > 0
      );
      if (!variant) {
        // If variant not found or inventory_quantity is 0 or less, skip this variant
        return null;
      }
      return {
        id: variant.id,
        label: x.displayLabel,
        selected: isSelected,
      };
    })
    .filter(Boolean);
  if (!isAnyOptionSelected && variants.length > 0) {
    variants[0].selected = true;
  }
  return variants;
};
window.sq.leftInitial = (store) => {
  const leftInitialItems =
    store.filters
      .find(
        (item) => item.stFieldName === "option_intials_13qgamc3lwo5xyzb2vrnzdme"
      )
      ?.items?.sort((a, b) => {
        const cleanLabelA = a.displayLabel.replaceAll("- ", "").trim();
        const cleanLabelB = b.displayLabel.replaceAll("- ", "").trim();
        return cleanLabelA.localeCompare(cleanLabelB);
      }) ?? [];
  return leftInitialItems;
};
// Handles selection and optionally resorts if data might have changed
window.sq.leftSock = (store, selectedValue) => {
  const filter = store.filters.find(
    (item) => item.stFieldName === "option_intials_13qgamc3lwo5xyzb2vrnzdme"
  );
  if (filter && filter.items) {
    let selectedItemLabel = null;
    filter.items.forEach((item) => {
      if (item.displayLabel === selectedValue) {
        item.selected = true;
        selectedItemLabel = item.displayLabel;
      } else {
        item.selected = false;
      }
    });
    if (selectedItemLabel) {
      const baseUrl = window.location.href.split("?")[0];
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(
        "option_intials_13qgamc3lwo5xyzb2vrnzdme",
        selectedItemLabel
      );
      const newUrl = `${baseUrl}?${queryParams.toString()}`;
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  }
};
window.sq.rightInitial = (store) => {
  const rightInitialItems =
    store.filters
      .find(
        (item) =>
          item.stFieldName === "option_right_initial_3wlk29ov9k4qf8vfxuf9epsa"
      )
      ?.items?.sort((a, b) => {
        const cleanLabelA = a.displayLabel.replaceAll("- ", "").trim();
        const cleanLabelB = b.displayLabel.replaceAll("- ", "").trim();
        return cleanLabelA.localeCompare(cleanLabelB);
      }) ?? [];
  return rightInitialItems;
};
window.sq.rightSock = (store, selectedValue) => {
  const filter = store.filters.find(
    (item) =>
      item.stFieldName === "option_right_initial_3wlk29ov9k4qf8vfxuf9epsa"
  );
  if (filter && filter.items) {
    let selectedItemLabel = null;
    filter.items.forEach((item) => {
      if (item.label === selectedValue) {
        item.selected = true;
        selectedItemLabel = item.label; // Capture the selected item's label
      } else {
        item.selected = false;
      }
    });
    if (selectedItemLabel) {
      const baseUrl = window.location.href.split("?")[0];
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(
        "option_right_initial_3wlk29ov9k4qf8vfxuf9epsa",
        selectedItemLabel
      );
      const newUrl = `${baseUrl}?${queryParams.toString()}`;
      window.history.pushState({ path: newUrl }, "", newUrl); // Update the URL without reloading
    }
  }
};

window.sq.collectionsocks = (store) => {
  return [
    {
      "label": "limited edition",
      "value": 15,
      "displayLabel": "limited edition",
      "isVisible": true
    },
    {
      "label": "limited edition cashmere blend",
      "value": 2,
      "displayLabel": "limited edition cashmere blend",
      "isVisible": true
    },
    {
      "label": "\"superlight\" filo di scozia uomo - luxury edition",
      "value": 13,
      "displayLabel": "\"superlight\" filo di scozia uomo - luxury edition",
      "isVisible": true
    },
    {
      "label": "\"superfine\" cotone stretch uomo  - luxury edition",
      "value": 5,
      "displayLabel": "\"superfine\" cotone stretch uomo  - luxury edition",
      "isVisible": true
    },
    {
      "label": "caldo cotone stretch uomo",
      "value": 36,
      "displayLabel": "caldo cotone stretch uomo",
      "isVisible": true
    },
    {
      "label": "sport",
      "value": 4,
      "displayLabel": "sport",
      "isVisible": true
    },
    {
      "label": "Fashion Uomo",
      "value": 8,
      "displayLabel": "Fashion Uomo",
      "isVisible": true
    },
    {
      "label": "calze uomo con doppie iniziali",
      "value": 8,
      "displayLabel": "calze uomo con doppie iniziali",
      "isVisible": true
    },
    {
      "label": "calze donna",
      "value": 17,
      "displayLabel": "calze donna",
      "isVisible": true
    },
    {
      "label": "fashion donna",
      "value": 17,
      "displayLabel": "fashion donna",
      "isVisible": true
    },
    {
      "label": "calze bimbo",
      "value": 9,
      "displayLabel": "calze bimbo",
      "isVisible": true
    }
  ]
};




window.sq.collection = (store, selectedValue) => {
  const filter = store.filters.find(
    (item) => item.stFieldName === "system_collections"
  );
  if (filter && filter.items) {
    let selectedItemLabel = null;
    filter.items.forEach((item) => {
      if (item.label === selectedValue) {
        item.selected = true;
        selectedItemLabel = item.label; // Capture the selected item's label
      } else {
        item.selected = false;
      }
    });
    if (selectedItemLabel) {
      const baseUrl = window.location.href.split("?")[0];
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(
        "system_collections",
        selectedItemLabel
      );
      const newUrl = `${baseUrl}?${queryParams.toString()}`;
      window.history.pushState({ path: newUrl }, "", newUrl); // Update the URL without reloading
    }
  }
};

window.sq.gendersocks = (store) => {
  const leftInitialItems = store.filters.find(
    (item) => item.stFieldName === "tags_gender_fkjf2etocawwfks6plof1h9a"
  )?.items;
  return leftInitialItems;
};
window.sq.gender = (store, selectedValue) => {
  const filter = store.filters.find(
    (item) => item.stFieldName === "tags_gender_fkjf2etocawwfks6plof1h9a"
  );
  if (filter && filter.items) {
    let selectedItemLabel = null;
    filter.items.forEach((item) => {
      if (item.label === selectedValue) {
        item.selected = true;
        selectedItemLabel = item.label; // Capture the selected item's label
      } else {
        item.selected = false;
      }
    });
    if (selectedItemLabel) {
      const baseUrl = window.location.href.split("?")[0];
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(
        "tags_gender_fkjf2etocawwfks6plof1h9a",
        selectedItemLabel
      );
      const newUrl = `${baseUrl}?${queryParams.toString()}`;
      window.history.pushState({ path: newUrl }, "", newUrl); // Update the URL without reloading
    }
  }
};
window.sq.materialsocks = (store) => {
  const leftInitialItems = store.filters.find(
    (item) => item.stFieldName === "tags_material_kep5vbuct78wzlovwr62uru3"
  )?.items;
  return leftInitialItems;
};
window.sq.material = (store, selectedValue) => {
  const filter = store.filters.find(
    (item) => item.stFieldName === "tags_material_kep5vbuct78wzlovwr62uru3"
  );
  if (filter && filter.items) {
    let selectedItemLabel = null;
    filter.items.forEach((item) => {
      if (item.label === selectedValue) {
        item.selected = true;
        selectedItemLabel = item.label; // Capture the selected item's label
      } else {
        item.selected = false;
      }
    });
    if (selectedItemLabel) {
      const baseUrl = window.location.href.split("?")[0];
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(
        "tags_material_kep5vbuct78wzlovwr62uru3",
        selectedItemLabel
      );
      const newUrl = `${baseUrl}?${queryParams.toString()}`;
      window.history.pushState({ path: newUrl }, "", newUrl); // Update the URL without reloading
    }
  }
};
window.sq._getVariants = (item) => {
  const opt = item.options.find((x) => x.name.toLowerCase() === "iniziali");
  if (!opt) return [];
  const optionField = `option${opt.position}`;
  return item.variants
    .filter((x) => x.inventory_quantity > 0)
    .map((x) => {
      return {
        id: x.id,
        label: x[optionField],
      };
    });
};

//functions for different options
window.sq._initialSelector = (item) => {
  const opt = item?.options.find(
    (x) => x.name.toLowerCase() === "seleziona le tue iniziali"
  );
  if (!opt) return [];
  const optionField = `option${opt.position}`;
  return item.variants
    .filter((x) => x.inventory_quantity > 0)
    .map((x) => {
      return {
        id: x.id,
        label: x[optionField],
      };
    });
};
window.sq._colore = (item) => {
  const opt = item?.options.find((x) => x.name === "Colore Ricamo");
  if (!opt) return [];
  const optionField = `option${opt.position}`;
  return item.variants
    .filter((x) => x.inventory_quantity > 0)
    .map((x) => {
      return {
        id: x.id,
        label: x[optionField],
      };
    });
};
window.sq._seleziona = (item) => {
  const opt = item?.options.find(
    (x) => x.name.toLowerCase() === "1° calzino (seleziona lettera)"
  );
  if (!opt) return [];
  const optionField = `option${opt.position}`;
  return item.variants
    .filter((x) => x.inventory_quantity > 0)
    .map((x) => {
      return {
        id: x.id,
        label: x[optionField],
      };
    });
};
window.sq._invisibli = (item) => {
  const opt = item?.options.find(
    (x) => x.name.toLowerCase() === "Invisibili - Fantasmini - 1 Paio"
  );
  if (!opt) return [];
  const optionField = `option${opt.position}`;
  return item.variants
    .filter((x) => x.inventory_quantity > 0)
    .map((x) => {
      return {
        id: x.id,
        label: x[optionField],
      };
    });
};
window.sq.onData = (searchResults) => {
  // if (Shopify.locale === "it") {
  //   return searchResults?.results;
  // }
  // const fetchData = searchResults?.results?.map((r) => {
  //   return fetch("/" + Shopify.locale + "/products/" + r.handle + ".json")
  //     .then((res) => res?.json())
  //     .then((d) => {
  //       (r.title = d.product.title), (r.price = d.product.variants[0].price);
  //     });
  //   //.catch(e => r.title)
  // });
  // // Promise.all(fetchData);
  return searchResults?.results;
};

//XHR for best selling on collection pages
(function (XHR) {
  "use strict";
  var open = XHR.prototype.open;
  var send = XHR.prototype.send;
  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url; // Save the URL to the instance
    open.call(this, method, url, async, user, pass);
  };
  XHR.prototype.send = function (data) {
    var url = this._url;
    let location = window.location.href;
    if (
      url &&
      url.toLowerCase() ===
      "https://lkg5ny3vvcwq6d7tzephr5ga-fast.searchtap.net/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);
      let sorting = body.sort;
      if (!location.includes("/all")) {
        if (!sorting.includes("bestSellingScore")) {
          sorting.unshift("bestSellingScore");
        }
      }
      // Remove sortOrderFor_ if bestSellingScore is supposed to be in the array
      if (sorting.includes("bestSellingScore")) {
        const index = sorting.indexOf("sortOrderFor_");
        if (index > -1) {
          sorting.splice(index, 1);
        }
      }
      // If on search page and sort length is more than 1, remove bestSellingScore
      if (location.includes("/search") && sorting.length > 1) {
        const bestSellingIndex = sorting.indexOf("bestSellingScore");
        if (bestSellingIndex > -1) {
          sorting.splice(bestSellingIndex, 1);
        }
      }
      data = JSON.stringify(body); // Re-stringify the modified body
    }
    send.call(this, data); // Proceed with the send call
    fetchCartContents()
  };
})(XMLHttpRequest);

// inside this searchpage function is calling. and also for showing the whatsapp icon for bodt by innerhtml
window.onload = function () {
  setTimeout(() => {
    //searchpage();

    collectiontext();
    // document.querySelector("#zoko-8aec0844-b70f-11ec-b909-0242ac120002").remove();
    var z = document.createElement("p"); // is a node
    z.addEventListener("click", () => {
      window
        .open(
          "https://wa.me/+393351825309?text=Benvenuto a Individual Socks. Come possiamo aiutarti?",
          "_blank"
        )
        .focus();
    });
    const zika = `<div id="zoko-8aec0844-b70f-11ec-b909-0242ac120002"><div class="reset23947hdfjue8934" style="height: auto; width: 340px; top: unset; bottom: 10px; right: unset; left: 10px; position: fixed; box-sizing: border-box; display: flex; flex-direction: column-reverse; z-index: 9999999; font-size: 14px;"><div><style>
        .reset23947hdfjue8934 *{
           box-sizing: border-box;
           pointer-events: unset;
        }
        .reset23947hdfjue8934 a{
            font-size: 12px !important;
        }
        .zoko_legal > p{
            font-size: 8px !important;
            line-height: 11px;
        }
        a.zoko_powered {
            font-size: 6px !important;
            line-height: 11px !important;
        }
    </style></div><img src="https://cdn.live.zoko.io/store/customers/05e30ba3-727d-45fd-9a20-ba0f4a48dc74-zo-ko-whatsapp+icon+whatsapp+logo+whatsapp_3584845.png" style="position: absolute; bottom: 0px; cursor: pointer; width: 56px; height: 56px; border-radius: 16px; pointer-events: unset; object-fit: cover; box-sizing: border-box; right: unset; left: 12px; box-shadow: rgba(20, 20, 20, 0.08) 0px 16px 32px -6px, rgba(20, 20, 20, 0.04) 0px 60px 120px -4px; max-width: unset; max-height: unset;"></div></div>`;
    z.innerHTML = zika;
    document.body.appendChild(z);
  }, 100);
};

// Array to track the event counts
window.sqEventArray = [];

// window.addEventListener("load", () => {
//   //console.log("i am loaded");
//   if (!blockedPaths.includes(window.location.pathname)) {
//     fetchCartContents();
//   }
// });

// Initialize totalQuantity globally to track total items in the cart
var totalQuantity = 0;

window.sq._addToCart = (item, isValidItem = false) => {
  let button = document.getElementById(`sq-btn-${item.id}`);
  button.value = "AGGIUNGENDO...";
  const leftVal = document.getElementById(`item-left-${item.id}`)?.value;
  const rightVal = document.getElementById(`item-right-${item.id}`)?.value;

  // Removed limited edition paths and related items
  let items = [];
  if (leftVal) {
    items.push({ id: leftVal, quantity: 1 });
  }
  if (rightVal) {
    items.push({ id: rightVal, quantity: 1 });
  }

  function fireA2CDLV(itemObj) {
    const mergedItems = [];

    itemObj.forEach((sqitem) => {
      const existingItem = mergedItems.find((i) => i.id === sqitem.id);
      if (existingItem) {
        existingItem.quantity += sqitem.quantity;
      } else {
        mergedItems.push({ ...sqitem });
      }
    });

    const transformedItems = mergedItems.map((sqitem) => ({
      item_id: sqitem.id,
      quantity: sqitem.quantity || 1,
      price: item.price || 0,
      item_category: item.productCategory || null,
      item_name: item.title || null,
      item_brand: item.vendor || null,
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    const sqObj = {
      event: 'sq_a2c',
      ecommerce: {
        items: transformedItems,
      },
    };
    //console.log(sqObj, item);
    window.dataLayer.push(sqObj);
  }

  const refreshCart = () => {
    const cartIcon = document.querySelector("a.cart.header__icon-wrapper.tap-area");
    if (cartIcon) {
      cartIcon.click();
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  };

  const addItemsToCart = (items) => {
    const body = {
      items: items,
    };
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((data) => {
        button.value = "AGGIUNGI AL CARRELLO";
        return data;
      })
      .catch((er) => {
        button.value = "AGGIUNGI AL CARRELLO";
        throw er;
      });
  };

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const isBundleCollection = true; // Default to true as there are no specific collection checks

      if (leftVal && rightVal) {
        if (isBundleCollection) {
          addItemsToCart(items).then((cartItems) => {
            totalQuantity += items.reduce((acc, item) => acc + item.quantity, 0);
            //console.log("Default Product need to be added ! OUter", totalQuantity);
            if (totalQuantity % 4 === 0 && totalQuantity > 2) {
              //console.log("Adding special product to cart:", "48641034715464");
              addItemsToCart([
                {
                  id: "48641034715464",
                  quantity: 1,
                },
              ]).then(() => {
                if (!blockedPaths.includes(window.location.pathname)) {
                  fetchCartContents();
                  //searchpage();
                  collectiontext();
                }
                refreshCart();
                //searchpage();
                collectiontext();

                // Redirect to the specified URL after cart operations are complete

              });
            } else {
              if (!blockedPaths.includes(window.location.pathname)) {
                fetchCartContents();
                //searchpage();
                collectiontext();
              }
              refreshCart();
              //searchpage();
              collectiontext();
            }
          });
        } else {
          addItemsToCart(items).then((data) => {
            if (!blockedPaths.includes(window.location.pathname)) {
              fetchCartContents();
              //searchpage();
            }
            refreshCart();
            //searchpage();
            collectiontext();
          });
        }
      } else {
        addItemsToCart([
          {
            id: item.variants[0].id,
            quantity: 1,
          },
        ])
          .then((data) => {
            button.value = "AGGIUNGI AL CARRELLO";
            if (!blockedPaths.includes(window.location.pathname)) {
              fetchCartContents();
            }
            refreshCart();
            //searchpage();
            collectiontext();
          })
          .catch((er) => {
            button.value = "AGGIUNGI AL CARRELLO";
          });
      }
    })
    .catch((error) => {
      button.value = "AGGIUNGI AL CARRELLO";
    });
};

async function fetchCartContents() {
  const excludedProductIds = [48641034715464, 44588083314983, 48938367549768,49324735365448]; // Exclude these specific product IDs
  let tq = 0;
  console.log("hiii");
  
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    console.log("Cart contents:", cart);

    for (const item of cart.items) {
      console.log(`Item ID: ${item.id}`);
      console.log(`Quantity: ${item.quantity}`);

      // Try fetching tags from item.results[0].tags if available
      let tags = [];
      if (item.results && Array.isArray(item.results) && item.results.length > 0) {
        tags = item.results[0].tags || [];
        console.log(`Tags from cart: ${tags}`);
      } else {
        console.log("No tags found in results. Trying to fetch tags from product data...");

        // Fetch tags from the product data if not present directly
        try {
          const productResponse = await fetch(`/products/${item.handle}.json`);
          const productData = await productResponse.json();
          tags = productData.product.tags || [];
          console.log("Fetched Tags from product data:", tags);
        } catch (error) {
          console.error("Error fetching product data:", error);
        }
      }

      // Exclude the item if it is in the excluded product IDs or has the "limited_edition" tag
      if (!excludedProductIds.includes(item.id) && !tags.includes("limited_edition")) {
        tq += item.quantity; // Accumulate quantity only for non-excluded items
      }
    }

    console.log(`Total quantity of items in cart (excluding special products and limited edition items): ${tq}`);
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
}



const blockedPaths = [];


// for limites edition add to cart
window.sq._addToCartss = (item, isValidItem = false) => {
  let button = document.getElementById(`sq-btn-${item.id}`);
  button.value = "AGGIUNGENDO...";

  const leftVal = document.getElementById(`item-left-${item.id}`)?.value;
  const rightVal = document.getElementById(`item-right-${item.id}`)?.value;

  let items = [
    {
      id: leftVal,
      quantity: 1,
    },
    {
      id: rightVal,
      quantity: 1,
    },
  ];

  const addItemsToCart = (items) => {
    const body = { items: items };
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((data) => {
        //console.log("Cart add response:", data);
        button.value = "AGGIUNGI AL CARRELLO";
        document.querySelector("a.cart.header__icon-wrapper.tap-area")?.click();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetchCartContents(); // Fetch and log the cart contents after adding items
      })
      .catch((er) => {
        //console.error("Error adding items to cart:", er);
        button.value = "AGGIUNGI AL CARRELLO";
      });
  };

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      //console.log("Current cart contents:", cart);

      if (leftVal && rightVal) {
        addItemsToCart(items);
      } else {
        const body1 = {
          items: [
            {
              id: item.variants[0].id,
              quantity: 1,
            },
          ],
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body1),
        })
          .then((r) => r.json())
          .then((data) => {
            //console.log("Cart add response for single item:", data);
            button.value = "AGGIUNGI AL CARRELLO";
            document.querySelector("a.cart.header__icon-wrapper.tap-area")?.click();
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            fetchCartContents(); // Fetch and log the cart contents after adding single item
          })
          .catch((er) => {
            //console.error("Error adding single item to cart:", er);
            button.value = "AGGIUNGI AL CARRELLO";
          });
      }
    })
    .catch((error) => {
      //console.error("Error fetching cart contents:", error);
      button.value = "AGGIUNGI AL CARRELLO";
    });
};

